import AxiosService from "./axiosServices";
// const axiosService = new AxiosService();

export default class processService {
  getHeaders = () => {
    return {
      headers: {
        "content-Type": "Application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: localStorage.getItem("token"),
      },
    };
  };

  getParaList = (params) => {
    return AxiosService.Get(`api/cam/pc/parameter-hierarchy-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

  addParameter = (data) => {
    return AxiosService.Post(`api/cam/pc/create-parameter/`, data, {
      ...this.getHeaders(),
    });
  };

  getMetaList = () => {
    return AxiosService.Get(`api/cam/pc/dropdown-all/`, {
      ...this.getHeaders(),
      // params: params,
    });
  };

  getDerivedFormulaSourceParameters = (unitOpId) => {
    return AxiosService.Get(
      `api/cam/pc/derived-formula-source-parameters/`,
      {
        ...this.getHeaders(),
        params: { unit_op_id: unitOpId },
      }
    );
  };



  deletePara = (obj) => {
    return AxiosService.Delete(`api/cam/pc/delete-parameter/`, obj);
  };

  updatePara = (obj) => {
    return AxiosService.Put(
      `api/cam/pc/update-parameter-metadata/`,
      obj,
      this.getHeaders()
    );
  };




  // phase
  addPhase = (data, obj) => {
    return AxiosService.Post(`api/cam/pc/create-phase/`, data, {
      ...this.getHeaders(),
    });
  };


  getPhaseList = (params) => {
    return AxiosService.Get(`api/cam/pc/phase-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

  deletePhase = (obj) => {
    return AxiosService.Delete(`api/cam/pc/delete-phase/`, obj);
  };

  //table
  addTable = (data, obj) => {
    return AxiosService.Post(`api/cam/pc/create-table-level/`, data, {
      ...this.getHeaders(),
    });
  };

  updatePhase = (obj) => {
    return AxiosService.Put(
      `api/cam/pc/update-phase/`,
      obj,
      // params,
      true,
      this.getHeaders()
    );
  };
  updateTable = (obj) => {
    return AxiosService.Put(
      `api/cam/pc/update-table-level/`,
      obj,
      // params,
      true,
      this.getHeaders()
    );
  };

  deleteTable = (obj) => {
    return AxiosService.Delete(`api/cam/pc/delete-table-level/`, obj);
  };




  getTableList = (params) => {
    return AxiosService.Get(`api/cam/pc/table-level-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };


  reOrderSheet = (data) => {
    return AxiosService.Put(`api/cam/pc/reorder-sheets/`, data, {
      ...this.getHeaders(),
    });
  };

  reOrderColumn = (data) => {
    return AxiosService.Put(`api/cam/pc/reorder-columns/`, data, {
      ...this.getHeaders(),
    });
  }

  restoreParameter = (data) => {
    return AxiosService.Post(`api/cam/pc/restore-parameter/`, data, {
      ...this.getHeaders(),
    });
  }

  templateView = (data) => {
    return AxiosService.Get(`api/cam/pc/template-preview/`, {
      params: data,
      ...this.getHeaders(),
    });
  }

  approvePara = (obj) => {
    return AxiosService.Post(`api/cam/pc/approve-template/`, obj);
  };
}






